const BulkContactSelectColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 80
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 200
  },
  {
    title: 'Contact Group',
    dataIndex: 'contact_group',
    sorter: (a, b) => (a.contact_group || '').localeCompare(b.contact_group || ''),
    width: 200
  },
  {
    title: 'Email',
    dataIndex: 'email',
    sorter: (a, b) => (a.email || '').localeCompare(b.email || ''),
    width: 250
  }
];

export { BulkContactSelectColumn };
